import { render, staticRenderFns } from "./LayoutProgramParameters.vue?vue&type=template&id=35c3d197&scoped=true&"
import script from "./LayoutProgramParameters.vue?vue&type=script&lang=js&"
export * from "./LayoutProgramParameters.vue?vue&type=script&lang=js&"
import style0 from "./LayoutProgramParameters.vue?vue&type=style&index=0&id=35c3d197&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3d197",
  null
  
)

export default component.exports